import React, { Component } from 'react';
import "./style.less";
import RewardTable from './RewardTable';
import { getpromoCodeUse } from "@/api/promoCodeUse";

class MyReward extends Component{
    constructor() {
        super();
        this.state = {
            promoCodeUse: [],
        }
      }
      componentDidMount() {
        getpromoCodeUse().then(message => {
            this.setState({
                promoCodeUse: message,
            })
        });
    }
   render() {
       return(
           <div>
               <sapn className="rewardMessage">本月累积邀请<sapn className="num">{this.state.promoCodeUse.monthUserCount}</sapn>位用户</sapn>
               <sapn className="rewardMessage">累积邀请<sapn className="num">{this.state.promoCodeUse.totalUserCount}</sapn>位用户</sapn>
               <span className="rewardMessage">累积获得<sapn className="num">{this.state.promoCodeUse.rebateAmount && this.state.promoCodeUse.rebateAmount/100}</sapn>元奖励</span> 
               <div className="rewardTitle1">奖励记录：</div> 
               <RewardTable></RewardTable>
           </div>
       );
   }
}
export default MyReward;